import { Moon } from 'lunarphase-js';

import { S3_HOST } from '@app/assets';

export const getMoonPhaseAndDay = (year: number, month: number, day: number) => {
  let jd;

  if (month < 3) {
    year--;
    month += 12;
  }

  ++month;
  const c = 365.25 * year;
  const e = 30.6 * month;
  jd = c + e + day - 694039.09;
  jd /= 29.53058867;
  const b = parseInt(jd as unknown as string);
  jd -= b;

  const moonDay = Math.round(jd * 29);

  const moonPhase = getMoonPhase();

  return {
    phase: moonPhase,
    moonDay,
  };
};

export const formatImgSrc = (name: string, type: 'moon' | 'symbol') => {
  if (type === 'moon') {
    return `${S3_HOST}/matrix/moonPhoto/icon_${name}.png`;
  } else {
    return `${S3_HOST}/daily-energy/symbolIcons/${name}`;
  }
};

export const getMoonPhase = (): number => {
  const age = Number(Moon.lunarAge().toFixed(4));

  const phases = [
    { id: 0, min: 0, max: 1.8456 }, // new moon
    { id: 1, min: 1.8456, max: 7.3826 }, // waxing 1
    { id: 2, min: 7.3826, max: 12.9196 }, // waxing 2
    { id: 3, min: 12.9196, max: 16.6109 }, // full moon
    { id: 4, min: 16.6109, max: 22.1479 }, // waning 1
    { id: 5, min: 22.1479, max: 27.6849 }, // waning 2
    { id: 0, min: 27.685, max: 29.5305 }, // new moon
  ];

  const phase = phases.find((p) => age >= p.min && age <= p.max);

  return phase?.id ?? 0;
};
